import { render, staticRenderFns } from "./RdsMenu.vue?vue&type=template&id=5fea4789&scoped=true&"
import script from "./RdsMenu.vue?vue&type=script&lang=js&"
export * from "./RdsMenu.vue?vue&type=script&lang=js&"
import style0 from "./RdsMenu.vue?vue&type=style&index=0&id=5fea4789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea4789",
  null
  
)

export default component.exports